import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const SuccessMessage = (message) => {
    toast.success(message);
}
export const ErrorMessage = (message) => {
    toast.error(message);
}